(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-main"] && !Shopify.designMode) return;
  try {
    
  class CartMain {
    constructor() {
      this.form = document.querySelector('.cart-main__form');
      this.init();
    }

    init() {
      // Quantity buttons
      document.querySelectorAll('[data-quantity-minus]').forEach(btn => {
        btn.addEventListener('click', (e) => {
          const line = e.currentTarget.dataset.quantityMinus;
          const input = document.querySelector(`.cart-item__quantity-input[data-line="${line}"]`);
          const currentValue = parseInt(input.value);
          if (currentValue > 0) {
            input.value = currentValue - 1;
            this.updateCart();
          }
        });
      });

      document.querySelectorAll('[data-quantity-plus]').forEach(btn => {
        btn.addEventListener('click', (e) => {
          const line = e.currentTarget.dataset.quantityPlus;
          const input = document.querySelector(`.cart-item__quantity-input[data-line="${line}"]`);
          const currentValue = parseInt(input.value);
          input.value = currentValue + 1;
          this.updateCart();
        });
      });

      // Remove buttons
      document.querySelectorAll('[data-remove-item]').forEach(btn => {
        btn.addEventListener('click', (e) => {
          const line = e.currentTarget.dataset.removeItem;
          const input = document.querySelector(`.cart-item__quantity-input[data-line="${line}"]`);
          input.value = 0;
          this.updateCart();
        });
      });
    }

    updateCart() {
      if (this.form) {
        this.form.submit();
      }
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    new CartMain();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  class FAQ {
    constructor() {
      this.items = document.querySelectorAll('.faq__question');
      this.init();
    }

    init() {
      this.items.forEach(button => {
        button.addEventListener('click', () => this.toggleItem(button));
      });
    }

    toggleItem(button) {
      const isExpanded = button.getAttribute('aria-expanded') === 'true';
      const answer = button.nextElementSibling;

      if (isExpanded) {
        button.setAttribute('aria-expanded', 'false');
        answer.style.maxHeight = null;
      } else {
        button.setAttribute('aria-expanded', 'true');
        answer.style.maxHeight = answer.scrollHeight + 'px';
      }
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    new FAQ();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class Header {
    constructor() {
      this.header = document.querySelector('.header');
      this.menuToggle = document.querySelector('.header__menu-toggle');
      this.mobileMenu = document.querySelector('.header__mobile-menu');
      this.mobileMenuBackdrop = document.querySelector('[data-mobile-menu-backdrop]');
      this.menuClose = document.querySelector('.header__mobile-menu-close');
      this.searchToggle = document.querySelector('.header__search-toggle');
      this.searchContainer = document.querySelector('.header__search-container');
      this.searchClose = document.querySelector('.header__search-close');
      this.searchInput = document.querySelector('.header__search-input');

      this.init();
    }

    init() {
      this.updateScrolledState();

      window.addEventListener('scroll', () => this.updateScrolledState(), { passive: true });

      this.menuToggle?.addEventListener('click', () => this.openMobileMenu());

      this.menuClose?.addEventListener('click', () => this.closeMobileMenu());
      this.mobileMenuBackdrop?.addEventListener('click', () => this.closeMobileMenu());

      const menuLinks = this.mobileMenu?.querySelectorAll('.header__mobile-menu-link') || [];
      menuLinks.forEach(link => {
        link.addEventListener('click', () => this.closeMobileMenu());
      });

      this.searchToggle?.addEventListener('click', () => this.openSearch());

      this.searchClose?.addEventListener('click', () => this.closeSearch());

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          if (this.searchContainer?.classList.contains('active')) {
            this.closeSearch();
          }
          if (this.mobileMenu?.classList.contains('active')) {
            this.closeMobileMenu();
          }
        }
      });

      document.addEventListener('click', (e) => {
        if (
          this.searchContainer?.classList.contains('active') &&
          !this.searchContainer.contains(e.target) &&
          !this.searchToggle?.contains(e.target)
        ) {
          this.closeSearch();
        }
      });
    }

    updateScrolledState() {
      if (window.scrollY > 64) {
        this.header?.classList.add('scrolled');
      } else {
        this.header?.classList.remove('scrolled');
      }
    }

    openMobileMenu() {
      this.mobileMenu?.classList.add('active');
      this.mobileMenuBackdrop?.classList.add('active');
      this.menuToggle?.setAttribute('aria-expanded', 'true');
      this.mobileMenu?.setAttribute('aria-hidden', 'false');
      this.mobileMenu?.removeAttribute('inert');
      document.body.classList.add('no-scroll');
    }

    closeMobileMenu() {
      this.mobileMenu?.classList.remove('active');
      this.mobileMenuBackdrop?.classList.remove('active');
      this.menuToggle?.setAttribute('aria-expanded', 'false');
      this.mobileMenu?.setAttribute('aria-hidden', 'true');
      this.mobileMenu?.setAttribute('inert', '');
      document.body.classList.remove('no-scroll');
      this.menuToggle?.focus();
    }

    openSearch() {
      this.searchContainer?.classList.add('active');
      this.searchToggle?.setAttribute('aria-expanded', 'true');
      setTimeout(() => this.searchInput?.focus(), 100);
    }

    closeSearch() {
      this.searchContainer?.classList.remove('active');
      this.searchToggle?.setAttribute('aria-expanded', 'false');
      this.searchToggle?.focus();
    }
  }

  new Header();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-grid"] && !Shopify.designMode) return;
  try {
    
  class ProductSlider {
    constructor(element) {
      this.slider = element;
      this.container = this.slider.querySelector('.product-grid__items');
      this.cards = this.slider.querySelectorAll('.product-card');
      this.prevBtn = this.slider.parentElement.querySelector('.product-grid__nav--prev');
      this.nextBtn = this.slider.parentElement.querySelector('.product-grid__nav--next');
      this.dotsContainer = this.slider.parentElement.parentElement.querySelector('[data-dots]');

      this.currentIndex = 0;
      this.totalSlides = Math.ceil(this.cards.length / this.getItemsPerPage());

      if (this.cards.length === 0) return;

      this.init();
    }

    init() {
      this.isCentered = this.slider.closest('[data-centered="true"]') !== null;

      this.createDots();
      this.updateButtons();
      this.attachEvents();
      this.updateCenteredState();
      this.updateSlider();

      let startX = 0;
      let isDragging = false;

      this.slider.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
        isDragging = true;
      }, { passive: true });

      this.slider.addEventListener('touchend', (e) => {
        if (!isDragging) return;
        const endX = e.changedTouches[0].clientX;
        const diff = startX - endX;

        if (Math.abs(diff) > 50) {
          if (diff > 0) {
            this.next();
          } else {
            this.prev();
          }
        }
        isDragging = false;
      });
    }

    getItemsPerPage() {
      if (window.innerWidth <= 600) return 1;
      if (window.innerWidth <= 900) return 2;
      return 3;
    }

    getGap() {
      if (window.innerWidth <= 600) return 16;
      if (window.innerWidth <= 900) return 24;
      return 32;
    }

    shouldShowSlider() {
      const itemsPerPage = this.getItemsPerPage();
      return this.cards.length > itemsPerPage;
    }

    updateCenteredState() {
      const wrapper = this.slider.closest('.product-grid__slider-wrapper');
      const showSlider = this.shouldShowSlider();

      if (this.isCentered && !showSlider) {
        wrapper?.classList.add('product-grid__slider-wrapper--centered');
        this.dotsContainer?.classList.add('product-grid__dots--hidden');
      } else {
        wrapper?.classList.remove('product-grid__slider-wrapper--centered');
        this.dotsContainer?.classList.remove('product-grid__dots--hidden');
      }
    }

    createDots() {
      if (!this.dotsContainer) return;

      this.totalSlides = Math.ceil(this.cards.length / this.getItemsPerPage());
      this.dotsContainer.innerHTML = '';

      if (this.totalSlides <= 1) return;

      for (let i = 0; i < this.totalSlides; i++) {
        const dot = document.createElement('button');
        dot.className = 'product-grid__dot';
        dot.type = 'button';
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        if (i === 0) {
          dot.classList.add('active');
          dot.setAttribute('aria-selected', 'true');
        } else {
          dot.setAttribute('aria-selected', 'false');
        }
        dot.addEventListener('click', () => this.goToSlide(i));
        this.dotsContainer.appendChild(dot);
      }
    }

    attachEvents() {
      this.prevBtn?.addEventListener('click', () => this.prev());
      this.nextBtn?.addEventListener('click', () => this.next());

      window.addEventListener('resize', () => {
        const newTotal = Math.ceil(this.cards.length / this.getItemsPerPage());
        if (newTotal !== this.totalSlides) {
          this.totalSlides = newTotal;
          this.currentIndex = Math.min(this.currentIndex, this.totalSlides - 1);
          this.createDots();
          this.updateSlider();
        }
        this.updateCenteredState();
      });
    }

    prev() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
        this.updateSlider();
      }
    }

    next() {
      if (this.currentIndex < this.totalSlides - 1) {
        this.currentIndex++;
        this.updateSlider();
      }
    }

    goToSlide(index) {
      this.currentIndex = index;
      this.updateSlider();
    }

    updateSlider() {
      const itemsPerPage = this.getItemsPerPage();
      const cardWidth = this.cards[0].offsetWidth;
      const gap = this.getGap();
      const offset = -(this.currentIndex * itemsPerPage * (cardWidth + gap));

      this.container.style.transform = `translateX(${offset}px)`;
      this.updateButtons();
      this.updateDots();
    }

    updateButtons() {
      if (this.prevBtn) {
        const isDisabled = this.currentIndex === 0;
        this.prevBtn.disabled = isDisabled;
        this.prevBtn.setAttribute('aria-disabled', String(isDisabled));
      }
      if (this.nextBtn) {
        const isDisabled = this.currentIndex === this.totalSlides - 1;
        this.nextBtn.disabled = isDisabled;
        this.nextBtn.setAttribute('aria-disabled', String(isDisabled));
      }
    }

    updateDots() {
      if (!this.dotsContainer) return;

      const dots = this.dotsContainer.querySelectorAll('.product-grid__dot');
      dots.forEach((dot, index) => {
        const isActive = index === this.currentIndex;
        dot.classList.toggle('active', isActive);
        dot.setAttribute('aria-selected', String(isActive));
      });
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-slider]').forEach(slider => {
      new ProductSlider(slider);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-main"] && !Shopify.designMode) return;
  try {
    
  // Gallery-only: the buy box lives in product-packages-selector, so this
  // section just handles thumbnail ↔ main-image switching.
  class ProductGallery {
    constructor() {
      this.container = document.querySelector('.product-main');
      if (!this.container) return;

      this.thumbnails = this.container.querySelectorAll('[data-thumbnail-index]');
      this.images = this.container.querySelectorAll('[data-image-index]');

      this.thumbnails.forEach(thumbnail => {
        thumbnail.addEventListener('click', () => {
          this.switchImage(thumbnail.dataset.thumbnailIndex);
        });
      });
    }

    switchImage(index) {
      this.thumbnails.forEach(thumb => {
        thumb.classList.remove('active');
        thumb.setAttribute('aria-pressed', 'false');
      });
      if (this.thumbnails[index]) {
        this.thumbnails[index].classList.add('active');
        this.thumbnails[index].setAttribute('aria-pressed', 'true');
      }

      this.images.forEach(img => img.classList.remove('active'));
      if (this.images[index]) {
        this.images[index].classList.add('active');
      }
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    new ProductGallery();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function loadRecommendations() {
      var container = document.querySelector('[data-recommendations]');
      if (!container) return;

      var section = container.closest('.product-recommendations');
      var productId = container.dataset.productId;
      if (!productId) {
        if (section) section.classList.add('product-recommendations--empty');
        return;
      }

      var sectionId = section ? section.dataset.sectionId : null;
      if (!sectionId) return;

      var url = '/recommendations/products?section_id=' + encodeURIComponent(sectionId) +
                '&product_id=' + encodeURIComponent(productId) +
                '&limit=4';

      fetch(url)
        .then(function(response) {
          if (!response.ok) return null;
          return response.text();
        })
        .then(function(html) {
          if (!html) {
            if (section) section.classList.add('product-recommendations--empty');
            return;
          }

          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var populated = doc.querySelector('[data-recommendations-populated]');

          if (populated && populated.children.length > 0) {
            container.innerHTML = populated.innerHTML;
          } else if (section) {
            section.classList.add('product-recommendations--empty');
          }
        })
        .catch(function(error) {
          console.error('Error fetching recommendations:', error);
          if (section) section.classList.add('product-recommendations--empty');
        });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', loadRecommendations);
    } else {
      loadRecommendations();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
